(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, '');
  const start = (scope = document) => {
    scope.querySelectorAll('[data-animal-stories]').forEach(root => {
      if (root.dataset.ready) return;
      const cards = [...root.querySelectorAll('[data-animal-story]')];
      const buttons = [...root.querySelectorAll('[data-animal-filter]')];
      const search = root.querySelector('[data-story-search]');
      const status = root.querySelector('.das-status');
      const empty = root.querySelector('.das-empty');
      let group = 'all';
      cards.forEach(card => { card.dataset.search = normalize(card.textContent); });
      const render = () => {
        const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const match = (group === 'all' || card.dataset.group === group) && terms.every(term => card.dataset.search.includes(term));
          card.hidden = !match;
          if (match) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.animalFilter === group)));
        status.textContent = root.dataset.countLabel.replace('{shown}', count).replace('{total}', cards.length);
        empty.hidden = count !== 0;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        group = button.dataset.animalFilter;
        render();
      }));
      search.addEventListener('input', render);
      root.querySelector('[data-story-reset]').addEventListener('click', () => {
        group = 'all'; search.value = ''; render(); search.focus();
      });
      render();
      root.querySelector('.das-controls').hidden = false;
      status.hidden = false;
      root.dataset.ready = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
